import { useHeroElement } from 'src/contexts/FirstHeroContext/FirstHeroContext';
import { isProduction } from 'src/lib/constants';
import { CmsEditorialHero } from './CmsEditorialHero';
import { CmsFormWithAssetHero } from './CmsFormWithAssetHero';
import { CmsFormWithBackgroundHero } from './CmsFormWithBackgroundHero';
import { CmsLargeAssetCenteredHero } from './CmsLargeAssetCenteredHero';
import { CmsLargeAssetLeftHero } from './CmsLargeAssetLeftHero';
import { CmsLargeAssetTopCenteredHero } from './CmsLargeAssetTopCenteredHero';
import { CmsLeftRightHero } from './CmsLeftRightHero';

const CmsHeroSwitch = ({ fields, sys }) => {
  const appearance = fields?.appearance;
  const component = useHeroElement(sys);
  switch (appearance) {
    case 'Editorial':
      return (
        <CmsEditorialHero fields={fields} sys={sys} component={component} />
      );
    case 'Left-Right':
      return (
        <CmsLeftRightHero fields={fields} sys={sys} component={component} />
      );
    case 'Large-Asset-Left':
      return (
        <CmsLargeAssetLeftHero
          fields={fields}
          sys={sys}
          component={component}
        />
      );
    case 'Large-Asset-Centered':
      return (
        <CmsLargeAssetCenteredHero
          fields={fields}
          sys={sys}
          component={component}
        />
      );
    case 'Large-Asset-Top-Centered':
      return (
        <CmsLargeAssetTopCenteredHero
          fields={fields}
          sys={sys}
          component={component}
        />
      );
    case 'Form-With-Background':
      return (
        <CmsFormWithBackgroundHero
          fields={fields}
          sys={sys}
          component={component}
        />
      );
    case 'Form-With-Asset':
      return (
        <CmsFormWithAssetHero fields={fields} sys={sys} component={component} />
      );
    default:
      if (!isProduction) {
        return <p>hmm something went wrong</p>;
      }
      return null;
  }
};

export default CmsHeroSwitch;
